import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for /setup/expense-catalogs/* — exists so the list, detail and edit
// screens nest under a common parent. No shared chrome; just renders the
// matched child.
export const Route = createFileRoute('/_authenticated/setup/expense-catalogs')({
  component: () => <Outlet />,
});
